import { render } from "./ClaimEmployeeAutocomplete.vue?vue&type=template&id=3747f3d1&scoped=true"
import script from "./ClaimEmployeeAutocomplete.vue?vue&type=script&lang=js"
export * from "./ClaimEmployeeAutocomplete.vue?vue&type=script&lang=js"

import "./ClaimEmployeeAutocomplete.vue?vue&type=style&index=0&id=3747f3d1&scoped=true&lang=css"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3747f3d1"]])

export default __exports__